import { render, staticRenderFns } from "./trainRoomOpen.vue?vue&type=template&id=67386dcb&scoped=true"
import script from "./trainRoomOpen.vue?vue&type=script&lang=js"
export * from "./trainRoomOpen.vue?vue&type=script&lang=js"
import style0 from "./trainRoomOpen.vue?vue&type=style&index=0&id=67386dcb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67386dcb",
  null
  
)

export default component.exports